export const siteConfig = {
  name: "Killed By Muppets Photography",
  tagline: "See The Game Differently!",
  email: "hello@killedbymuppets.com",
  phone: "07867428462",
  location: "Derby, UK",
  socialLinks: {
    instagram: "http://instagram.com/killedbymuppets_",
  },
};

export const aboutData = {
  headline: "Capturing The Moments That Define The Game",
  bio: [
    "I'm the eye behind Killed By Muppets Photography — a sports photographer obsessed with freezing the split-second moments that tell the real story of competition. Based in Derby, UK, I've spent years courtside capturing the raw intensity, emotion, and beauty of basketball.",
    "My approach is simple: get close, stay ready, and never blink. Whether it's a buzzer-beater, a bone-crushing block, or the quiet focus before a free throw, I'm there to document it all.",
    "While basketball is my first love, I'm expanding into other team sports and live music photography. The energy of a packed stadium or a roaring concert crowd hits the same — and I want to bottle that feeling in every frame.",
  ],
  stats: [
    { label: "Years of Experience", value: "8+" },
    { label: "Events Covered", value: "500+" },
    { label: "Photos Delivered", value: "50K+" },
    { label: "Happy Clients", value: "120+" },
  ],
  services: [
    {
      title: "Game Day Coverage",
      description: "Full event photography from warm-ups to the final buzzer. High-res edited images delivered within 48 hours.",
    },
    {
      title: "Team & Player Portraits",
      description: "Professional headshots and action portraits for teams, individual athletes, and promotional materials.",
    },
    {
      title: "Tournament Packages",
      description: "Multi-day tournament coverage with rapid turnaround for social media and press.",
    },
    {
      title: "Concert & Event Photography",
      description: "Live music and event coverage that captures the raw energy and atmosphere of the moment.",
    },
  ],
};

export const heroImage = "https://customer-assets.emergentagent.com/job_killed-by-muppets/artifacts/jfc7umlr__DSC0949-topaz.jpg";
